<div class="col-md-12 mb-30" [hidden]="Switcher_Viewer!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==2">جزئیات '{{inner_17025_Cat.title}}'</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==3">سوابق فرم '{{inner_17025_Cat.title}}'
      </h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="inner_17025_Cat.chart_type==2 && !Procssing" (click)="Set_Switcher_Viewer('Form',0)" type="button"
            class="btn btn-success"><i class="fa fa-plus"></i> بازگذاری اطلاعات جدید </button>
          <button *ngIf="inner_17025_Cat.chart_type==3 && !Procssing" (click)="Set_Switcher_Viewer('Form',0)" type="button"
            class="btn btn-success"><i class="fa fa-plus"></i> بازگذاری سابقه جدید </button>
          <button (click)="OnSet_Back_Action()" style="margin-right: 10px;" type="button" class="btn btn-warning"><i
              class="fa fa-mail-reply"></i> بازگشت </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">

          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>شناسه</th>
                <th>فایل</th>
                <th>عنوان</th>
                <th>ایجاد کننده</th>
                <th>ناریخ</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_ChartFile
              | paginate
                      : {
                          id: 'DataList_UserTable',
                          itemsPerPage: 50,
                          currentPage: page,
                          totalItems: DataList_ChartFile.length
                        }">
                <td>{{DataList_ChartFile.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td>
                  <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Protocol17025{{item.src}}"
                    *ngIf="item.src"><i class="fa fa-download"></i> دانلود </a>
                </td>
                <td>{{item.title}}</td>
                <td>{{item.username}}</td>
                <td>{{item.subdate}}</td>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" style="cursor: pointer;" (click)="Set_Switcher_Viewer('Form',item.id)"><i
                            class="fa fa-edit"></i>
                          ویرایش </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i
                            class="fa fa-remove"></i> حذف </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
    <pagination-controls id="DataList_UserTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event" ></pagination-controls>
  </div>
</div>


<div class="col-md-12 mb-30" *ngIf="Switcher_Viewer=='Form'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==2 && Selected_Protocol17025ChartFile.id==0">فرم ثبت اطلاعات جدید</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==3 && Selected_Protocol17025ChartFile.id==0">فرم ثبت سابقه جدید</h5>

      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==2 && Selected_Protocol17025ChartFile.id>0">فرم ویرایش اطلاعات </h5>
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==3 && Selected_Protocol17025ChartFile.id>0">فرم ویرایش سابقه</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">انتخاب فایل</label>
          <input type="file" (change)="upload(file_chart.files)" #file_chart placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">عنوان</label>
          <input type="text" class="form-control" [(ngModel)]="Selected_Protocol17025ChartFile.title" name="title_edit" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">توضیحات</label>
          <textarea class="form-control" [(ngModel)]="Selected_Protocol17025ChartFile.dsc" name="dsc_edit" placeholder="اینجا تایپ کنید ..."></textarea>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <app-Protocol17025Cat_Check
            [DataList_Protocol17025Cat]="DataList_Protocol17025Cat"
            [Selected_Protocol17025Cat]="Selected_Tag"
            (On_Get_Selected_Tag)="OnGet_Selected_Tag($event)">

          </app-Protocol17025Cat_Check>
        </div>
      </div>

      <button *ngIf="!InProccessingAdd" (click)="AddEdit()" type="button" class="btn btn-info"> ثبت اطلاعات <i
          class="fa fa-plus"></i></button>
      <button (click)="Set_Switcher_Viewer('List',0)" style="margin-right: 10px;" *ngIf="!InProccessingAdd"
        type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
    </div>

  </div>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">تایید حذف اطلاعات  '{{Selected_Protocol17025ChartFile.code}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Selected_Protocol17025ChartFile)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>
